import React from "react";

// region Imports - Components
import DialogConfirmAction from "@components/Dialog/ConfirmAction";
// endregion Imports - Components
// region Imports - Languages
import { ManagementMessages, GlobalMessages } from "@shared/languages/interfaces";
// endregion Imports - Languages

interface ConfirmValidationEmailDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  email: string;
  t: (key: string) => string;
}
const ConfirmValidationEmailDialog: React.FC<ConfirmValidationEmailDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  email,
  t
}) => {
  return (
    <DialogConfirmAction
      open={open}
      onClose={onClose}
      title={title}
      actions={[
        { text: t(GlobalMessages.no).toUpperCase(), action: onClose },
        {
          text: t(GlobalMessages.yes).toUpperCase(),
          action: onConfirm
        }
      ]}
    >
      {t(ManagementMessages.validationText)}
      <b> {email}</b><br /><br />
      {t(ManagementMessages.validationConfirmation)}
    </DialogConfirmAction>
  );
};

export default ConfirmValidationEmailDialog;
